'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../../../languageHandler');

var _RoomProfileSettings = require('../../../room_settings/RoomProfileSettings');

var _RoomProfileSettings2 = _interopRequireDefault(_RoomProfileSettings);

var _MatrixClientPeg = require('../../../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _ = require('../../../../..');

var _2 = _interopRequireDefault(_);

var _AccessibleButton = require('../../../elements/AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _matrixJsSdk = require('matrix-js-sdk');

var _dispatcher = require('../../../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _LabelledToggleSwitch = require('../../../elements/LabelledToggleSwitch');

var _LabelledToggleSwitch2 = _interopRequireDefault(_LabelledToggleSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var GeneralRoomSettingsTab = function (_React$Component) {
    (0, _inherits3.default)(GeneralRoomSettingsTab, _React$Component);

    function GeneralRoomSettingsTab() {
        (0, _classCallCheck3.default)(this, GeneralRoomSettingsTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GeneralRoomSettingsTab.__proto__ || (0, _getPrototypeOf2.default)(GeneralRoomSettingsTab)).call(this));

        _this.onRoomPublishChange = function (e) {
            var valueBefore = _this.state.isRoomPublished;
            var newValue = !valueBefore;
            _this.setState({ isRoomPublished: newValue });

            _MatrixClientPeg2.default.get().setRoomDirectoryVisibility(_this.props.roomId, newValue ? 'public' : 'private').catch(function () {
                // Roll back the local echo on the change
                _this.setState({ isRoomPublished: valueBefore });
            });
        };

        _this._onLeaveClick = function () {
            _dispatcher2.default.dispatch({
                action: 'leave_room',
                room_id: _this.props.roomId
            });
        };

        _this.state = {
            isRoomPublished: false // loaded async
        };
        return _this;
    }

    (0, _createClass3.default)(GeneralRoomSettingsTab, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                matrixClient: _MatrixClientPeg2.default.get()
            };
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _MatrixClientPeg2.default.get().getRoomDirectoryVisibility(this.props.roomId).then(function (result) {
                _this2.setState({ isRoomPublished: result.visibility === 'public' });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var AliasSettings = _2.default.getComponent("room_settings.AliasSettings");
            var RelatedGroupSettings = _2.default.getComponent("room_settings.RelatedGroupSettings");
            var UrlPreviewSettings = _2.default.getComponent("room_settings.UrlPreviewSettings");

            var client = _MatrixClientPeg2.default.get();
            var room = client.getRoom(this.props.roomId);

            var canSetAliases = true; // Previously, we arbitrarily only allowed admins to do this
            var canActuallySetAliases = room.currentState.mayClientSendStateEvent("m.room.aliases", client);
            var canSetCanonical = room.currentState.mayClientSendStateEvent("m.room.canonical_alias", client);
            var canonicalAliasEv = room.currentState.getStateEvents("m.room.canonical_alias", '');
            var aliasEvents = room.currentState.getStateEvents("m.room.aliases");

            var canChangeGroups = room.currentState.mayClientSendStateEvent("m.room.related_groups", client);
            var groupsEvent = room.currentState.getStateEvents("m.room.related_groups", "");

            return _react2.default.createElement(
                'div',
                { className: 'mx_SettingsTab mx_GeneralRoomSettingsTab' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_heading' },
                    (0, _languageHandler._t)("General")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_GeneralRoomSettingsTab_profileSection' },
                    _react2.default.createElement(_RoomProfileSettings2.default, { roomId: this.props.roomId })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'mx_SettingsTab_subheading' },
                    (0, _languageHandler._t)("Room Addresses")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_SettingsTab_subsectionText' },
                    _react2.default.createElement(AliasSettings, { roomId: this.props.roomId,
                        canSetCanonicalAlias: canSetCanonical, canSetAliases: canSetAliases,
                        canonicalAliasEvent: canonicalAliasEv, aliasEvents: aliasEvents })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section' },
                    _react2.default.createElement(_LabelledToggleSwitch2.default, { value: this.state.isRoomPublished,
                        onChange: this.onRoomPublishChange,
                        disabled: !canActuallySetAliases,
                        label: (0, _languageHandler._t)("Publish this room to the public in %(domain)s's room directory?", {
                            domain: client.getDomain()
                        }) })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'mx_SettingsTab_subheading' },
                    (0, _languageHandler._t)("Flair")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section mx_SettingsTab_subsectionText' },
                    _react2.default.createElement(RelatedGroupSettings, { roomId: room.roomId,
                        canSetRelatedGroups: canChangeGroups,
                        relatedGroupsEvent: groupsEvent })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'mx_SettingsTab_subheading' },
                    (0, _languageHandler._t)("URL Previews")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section' },
                    _react2.default.createElement(UrlPreviewSettings, { room: room })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'mx_SettingsTab_subheading' },
                    (0, _languageHandler._t)("Leave room")
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_SettingsTab_section' },
                    _react2.default.createElement(
                        _AccessibleButton2.default,
                        { kind: 'danger', onClick: this._onLeaveClick },
                        (0, _languageHandler._t)('Leave room')
                    )
                )
            );
        }
    }]);
    return GeneralRoomSettingsTab;
}(_react2.default.Component);

GeneralRoomSettingsTab.childContextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient)
};
GeneralRoomSettingsTab.propTypes = {
    roomId: _propTypes2.default.string.isRequired
};
exports.default = GeneralRoomSettingsTab;
module.exports = exports['default'];
//# sourceMappingURL=GeneralRoomSettingsTab.js.map